import { render, staticRenderFns } from "./56.vue?vue&type=template&id=0873d96a&scoped=true&"
var script = {}
import style0 from "./56.vue?vue&type=style&index=0&id=0873d96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873d96a",
  null
  
)

export default component.exports